module.exports = __webpack_public_path__ + "static/img/CAMDEN_OAK.b1be9aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/CAMDEN_OAK.jpg
// module id = RGH2
// module chunks = 0